// List of required environment variables to be validate that they exist, more elaborate validation can be added below.
const requiredVariables = [
  "BASE_IDENTITY_URL",
  "REGISTRY_URL",
  "DEFAULT_SIGN_IN_PATH",
  "AUTH_SERVICE_URL",
  "ADMIN_SERVICE_URL",
];

export class EnvironmentManager {
  /**
   *  Validates that the required environment variables have been injected
   *  by the Webpack build process.
   *  This should be called once when the application starts.
   */
  public static initialize(): void {
    console.info("[EnvironmentValidator] Validating environment variables...");
    this.validate();
  }

  /**
   *  Checks the process.env object for required variables.
   *  Throws an error if any required variable is missing.
   */
  private static validate(): void {
    requiredVariables.forEach((variable) => {
      // process.env is populated by webpack.DefinePlugin
      const val = process.env[variable];

      if (val === undefined || val === null) {
        this.stopApp(
          `An environment variable was not defined by the build process. Check your .env file and webpack.config.js.`
        );
      }
    });

    console.log(
      "[EnvironmentValidator] All required environment variables are defined."
    );
  }

  /**
   * Stops the application immediately with an error message.
   * @param message - The error message to display.
   */
  private static stopApp(message: string): void {
    console.error(`[EnvironmentValidator] Critical Error: ${message}`);
    // This is a good way to give immediate visual feedback during development.
    document.body.innerHTML = `<h1 style="color: red; padding: 2rem;">Application Configuration Error: ${message}</h1>`;
    throw new Error(message); // Stop all script execution
  }
}
